import React from "react";
import {Button, Typography} from "@material-ui/core";
import Modal from "../Modal/Modal";

const AutoshipDeleteModal = ({open, handleClose, handleSubmit}) => {
    return (<Modal visible={open} close={handleClose}>
        <div style={{
            padding: 32, display: "flex", flexDirection: "column", gap: 16, maxWidth: 600
        }}>
            <Typography variant="h4">Are you sure?</Typography>
            <Typography>This action will permanently remove this Autoship subscription.</Typography>
            <div style={{
                marginTop: 10, display: "flex", gap: 16
            }}>
                <Button variant="contained"
                        color="secondary"
                        size="small"
                        onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="contained"
                        color="primary"
                        size="small"
                        onClick={handleSubmit}>
                    Delete
                </Button>
            </div>
        </div>

    </Modal>);
};

export default AutoshipDeleteModal;
